import { ScrollFade } from '@/components/ui/scroll-fade';
import { Sidebar, SidebarContent, SidebarGroupLabel } from '@/components/ui/sidebar';
import { Heading5, MutedText } from '@/components/ui/typography';
import type { SidebarSelection } from './page-template-types';
import { PageTemplatesGroup } from './page-templates-group';

interface AddPageSidebarProps {
  selectedItem: SidebarSelection;
  onSelectItem: (key: SidebarSelection) => void;
}

export function AddPageSidebar({ selectedItem, onSelectItem }: AddPageSidebarProps) {
  return (
    <Sidebar collapsible="none" className="w-36 md:w-64 shrink-0 flex bg-background h-full">
      <ScrollFade className="flex-1 w-full min-h-0">
        <SidebarContent className="h-full overflow-visible">
          <SidebarGroupLabel className="sticky top-0 bg-background z-20 flex flex-col gap-0.5 items-start h-auto pb-2 px-0">
            <Heading5>Select Template</Heading5>
            <MutedText className="text-xs">
              Start your page design with a template. You can customize the page to fit your needs.
            </MutedText>
          </SidebarGroupLabel>
          <PageTemplatesGroup selectedItem={selectedItem} onSelectItem={onSelectItem} />
        </SidebarContent>
      </ScrollFade>
    </Sidebar>
  );
}
